<template>
  <VjCard>
    <h2>🔐 Willkommen zurück</h2>
    <p class="description">Gib deinen Zugangscode ein, um deine Bilder zu bearbeiten.</p>

    <form @submit.prevent="handleSubmit" class="login-form">
      <div class="input-group">
        <VjInputText v-model="authToken" label="Zugangscode" type="password" placeholder="Deinen Code hier eingeben" :disabled="isLoading" required labelPosition="outline" />
        <VjCheckbox v-model="rememberMe" label="Mich auf diesem Gerät merken" :disabled="isLoading" />
      </div>

      <div v-if="errorMessage" class="error-message">❌ {{ errorMessage }}</div>

      <VjButton type="submit" :disabled="!authToken.trim() || isLoading" :label="isLoading ? '⏳ Wird überprüft...' : '✓ Anmelden'" primary class="submit-btn" />
    </form>
  </VjCard>
</template>

<script setup lang="ts">
  import { upscalerPod } from '@/services/upscale.service';
  import { useTokenService } from '@/composables/useTokenService';
  import { ref, onMounted } from 'vue';

  const emit = defineEmits<{
    authenticated: [];
  }>();

  const tokenService = useTokenService();

  const authToken = ref('');
  const rememberMe = ref(false);
  const isLoading = ref(false);
  const errorMessage = ref('');

  onMounted(() => {
    console.log('[Login] Component mounted');
  });

  const handleSubmit = async () => {
    try {
      errorMessage.value = '';
      isLoading.value = true;
      console.log(authToken.value);
      // Validate token with worker
      console.log('[Login] Validating authentication token...');
      const isValid = await upscalerPod.validateToken(authToken.value);

      if (!isValid) {
        throw new Error('Der Zugangscode ist ungültig. Bitte versuche es erneut.');
      }

      // Token is valid - save it to storage
      tokenService.setToken(authToken.value, rememberMe.value);

      console.log('[Login] ✅ Authentication successful');
      console.log(`[Login] Remember me: ${rememberMe.value ? 'enabled (localStorage)' : 'disabled (sessionStorage)'}`);
      emit('authenticated');
    } catch (error) {
      errorMessage.value = error instanceof Error ? error.message : 'Anmeldung fehlgeschlagen. Bitte versuche es später erneut.';
      console.error('[Login] ❌ Authentication failed:', error);
      authToken.value = '';
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style scoped>
  .login-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 28px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .security-list {
    margin-top: 12px;
    padding-left: 20px;
  }

  .security-list li {
    margin-bottom: 8px;
    font-size: 0.9rem;
  }

  .error-message {
    color: #dc2626;
    font-weight: 600;
    margin: 16px 0;
  }
</style>
